<mat-toolbar class="subtitulo">Cadastro de Ocorrência de Beneficiário</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">
        
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <div ngModelGroup="comboBeneficiario" fxFlex="50" fxLayoutGap="20px" style="padding-top: 15px;">
                <mat-toolbar class="titulopartes">Beneficiário</mat-toolbar>
                <combo-beneficiario [showDisplayId]="false" 
                                    [obrigatorio]="true" 
                                    [selecionado]="filtro.aluno"
                                    [desabilitado]="isAtualizar"
                                    (valorChange)="onValorChangeAluno($event)">
                </combo-beneficiario>
            </div>

            <div ngModelGroup="comboFuncionario" fxFlex="50" fxLayoutGap="20px" style="padding-top: 15px;">
                <mat-toolbar class="titulopartes">Funcionário</mat-toolbar>
                <combo-funcionario [showDisplayId]="false" 
                                   [obrigatorio]="true" 
                                   [selecionado]="filtro.funcionario"
                                   [desabilitado]="isAtualizar"
                                   (valorChange)="onValorChangeFuncionario($event)">
                </combo-funcionario>
            </div>
        </div>

        <div fxLayout="row">

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="20%">
                <input matInput name="dataOcorrencia" [matDatepicker]="dataOcorrencia"
                    placeholder="Data da ocorrência" [(ngModel)]="ocorrenciaAluno.dataOcorrencia" required (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataOcorrencia"></mat-datepicker-toggle>
                <mat-datepicker #dataOcorrencia></mat-datepicker>
            </mat-form-field>


            <mat-form-field style="margin: 0 0 0 20px" fxFlex="20%">
                <input matInput name="dataCiencia" [matDatepicker]="dataCiencia"
                    placeholder="Data da ciência" [(ngModel)]="ocorrenciaAluno.dataCiencia" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataCiencia"></mat-datepicker-toggle>
                <mat-datepicker #dataCiencia></mat-datepicker>
            </mat-form-field>


            <mat-form-field fxFlex="20%" fxLayoutGap="20px" fxFlexOffset="20px">
                <mat-label>Selecione um tipo de ocorrência</mat-label>
                <mat-select [(ngModel)]="ocorrenciaAluno.tipoOcorrenciaAluno.id" name="tipoOcorrenciaAluno"
                            required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let d of listaDeTipoOcorrencia" [value]="d.id">
                        {{d.tipoOcorrencia}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="listaDeTipoOcorrencia?.length === 0" align="start">Nenhum tipo de ocorrência cadastrado
                </mat-hint>
            </mat-form-field>


        </div>

        <div fxLayout="row">
            <mat-form-field style="margin: 0 0 0 20px" fxFlex="50%">
                <mat-label>Descrição da ocorrência</mat-label>
                <input #descricao matInput name="descricao" [(ngModel)]="ocorrenciaAluno.descricao" maxlength="200"
                    required>
                <mat-hint align="start">{{descricao.value.length}} / 200</mat-hint>
            </mat-form-field>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="50%">
                <mat-label>Local da ocorrência</mat-label>
                <input #local matInput name="local" [(ngModel)]="ocorrenciaAluno.local" maxlength="200">
                <mat-hint align="start">{{local.value.length}} / 200</mat-hint>
            </mat-form-field>

        </div>


        <div *ngIf="ocorrenciaAluno.funcionario.id" style="margin-right: 50px">
            <dados-funcionario [funcionario]=ocorrenciaAluno.funcionario></dados-funcionario>
        </div>

        <div *ngIf="ocorrenciaAluno.aluno.id" style="margin-right: 50px">
            <dados-aluno [aluno]=ocorrenciaAluno.aluno></dados-aluno>
        </div>


    </form>

    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
            Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
        </button>
        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>
    </div>

</div>
